<template>
  <BamLink :to="getItemTo(item)" class="featured-item item" @click.right.prevent="openItemPreview">
    <div class="top flex-row">
      <ItemPrice :price="item.price" :inline="true" />
      <ItemTimer :item="item" :short="true" />
    </div>
    <ItemPreview
      v-if="item.ss >= 1"
      ref="item_preview"
      :style="picture_wrapper ? `top: ${picture_wrapper.offsetTop}px` : 'top: 130px'"
      :item="item"
      :side="is_right"
    />
    <div ref="picture_wrapper" class="picture-wrapper" @mousemove="pictureMouseIn">
      <ItemPicture
        width="93"
        height="70"
        :hide="is_right && !!item?.thumbnail_reverse"
        :resize="!item.thumbnail"
        :img="item.thumbnail || item.icon"
        :fallback="item.icon"
      >
        <template v-if="item?.thumbnail_reverse" #default>
          <BamLazyImg
            v-show="is_right"
            img-class="img-item"
            width="93"
            height="70"
            :src="item.thumbnail_reverse"
            :fallback="item.icon"
          />
        </template>
      </ItemPicture>
    </div>
    <ItemFeaturedName :item="item" :sub="true" />
    <ItemFloat v-if="item.float_value" :value="item.float_value" :display_bar="true" :float_rank="item.float_rank" :fixed="6" :paint_id="item.paint_id">
      <div class="exterior item-text" />
    </ItemFloat>
  </BamLink>
</template>

<script setup>
import { getItemTo } from '@/helper/steam.js';
import { BamLink } from 'bambam-router';
import { defineAsyncComponent, ref } from 'vue';
import ItemPrice from '@/component/item/ItemPrice.vue';
import ItemPicture from '@/component/item/ItemPicture.vue';
import ItemFloat from '@/component/item/ItemFloat.vue';
import ItemTimer from '@/component/item/ItemTimer.vue';
import ItemFeaturedName from '@/component/item/ItemFeaturedName.vue';

const ItemPreview = defineAsyncComponent(() => import('@/component/item/ItemPreview.vue'));
const BamLazyImg = defineAsyncComponent(() => import('bambam-component-core/BamLazyImg.vue'));

defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const item_preview = ref();
const picture_wrapper = ref();
const is_right = ref(false);

const openItemPreview = () => {
  if (item_preview.value) {
    item_preview.value.openItemPreview();
  }
};

const pictureMouseIn = (e) => {
  const half = picture_wrapper.value.clientWidth / 2;
  const pos = e.offsetX;

  is_right.value = pos >= half;
};
</script>
